import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import { ReactComponent as FacebookIcon } from "images/facebook-svgrepo-com.svg";
import { ReactComponent as TiktokIcon } from "images/tiktok-svgrepo-com.svg";
import { ReactComponent as InstagramIcon } from "images/instagram-fill.svg";

const LINKEDIN_ICON_SRC = "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/LOGO%20for%20website/icons8-linkedin.svg";
const INDEED_ICON_SRC = "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/Indeed_Symbol_0.svg";

/* ===== 新增：顶部 Newsletter / App 下载栏 ===== */
const NewsletterBar = tw.div`py-8 relative bg-light-500 -mx-8 px-8 text-dark-500`;
const NewsletterInner = styled.div`
  ${tw`max-w-screen-xl mx-auto py-10 lg:py-16 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 relative`}

  @media (min-width: 768px) {
    &::before {
      content: "";
      position: absolute;
      top: 25%;
      bottom: 25%;
      left: 50%;
      transform: translateX(-50%);
      width: 1px;
      background-color: #b7b7b7;
      pointer-events: none;
    }
  }
`;

/* 左列（Newsletter） */
const NLHeading = tw.h4`font-normal text-lg sm:text-xl`;
const NLText = tw.p`mt-2 text-sm sm:text-base max-w-xl font-normal`;
const InputWrap = styled.div`
  ${tw`mt-4 max-w-md relative`}
`;
const EmailInput = styled.input`
  ${tw`bg-light-500 border border-dark-500 text-dark-500 w-full`}
  border-radius: 5px;
  padding: 10px 44px 10px 12px;
  line-height: 1.2;
  outline: none;
  transition: box-shadow .2s ease, border-color .2s ease;
  ::placeholder { color: rgba(20,19,59,0.6); }
  &:focus { box-shadow: 0 0 0 3px rgba(20,19,59,0.12); border-color: #14133B; }
`;

const InputButton = styled.a`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: #fffbdc;
  color: #14133b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 16px;
  transition: transform 0.18s ease, box-shadow 0.18s ease;


  &:active {
    transform: translateY(-50%);
    box-shadow: none;
  }
`;

/* 右列（下载 App）— PC 端左侧加分割线 */
const RightSplit = tw.div`
  border-t border-dark-500 pt-6
  md:border-t-0 md:pt-0 md:pl-8
`;

const AppHeading = tw.h4`font-normal text-lg sm:text-xl`;
const AppLinks = tw.div`mt-3 flex flex-col gap-2`;
const AppLink = tw.a`inline-flex items-center font-normal hover:opacity-75 transition`;

/* ===== 原有 Footer ===== */
const Container = tw.div`relative bg-dark-500 -mx-8 -mb-8 px-8 text-primary-500`;
const FiveColumns = tw.div`max-w-screen-xl mx-auto py-16 lg:py-20 flex flex-wrap justify-between`;

const Column = tw.div`md:w-1/5`;
const WideColumn = tw(Column)`w-full md:w-2/5 mb-10 md:mb-0 flex flex-col items-center gap-4`;

const ColumnHeading = tw.h5`font-normal`;

const LinkList = tw.ul`mt-4 text-sm font-normal`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:text-primary-300 hocus:border-primary-500 pb-1 transition duration-300`;

const LogoContainer = styled.div`
  ${tw`flex items-center justify-center`}
`;
const LogoImg = tw.img`w-40 pt-8 md:pt-0`;
const LogoText = tw.h5`ml-2 text-xl font-normal text-dark-500`;

const CompanyDescription = tw.p`mt-4 max-w-xs font-normal text-sm mx-auto md:mx-0 md:mr-4 `;

const SocialLinksContainer = styled.div`
  ${tw`mt-2 flex items-center justify-center gap-3`}
`;
const SocialLink = styled.a.attrs({
      target: "_blank",
      rel: "noopener noreferrer",
    })`
    ${tw`cursor-pointer inline-flex items-center justify-center p-2 rounded-full bg-primary-500 text-dark-100 hover:bg-primary-300 transition duration-300`}
    svg, img {
        ${tw`w-5 h-5`} display: block;
    }
`;

export default () => {
  return (
      <>
        {/* 新增顶部栏 */}
        <NewsletterBar>
          <NewsletterInner>
            {/* 左列：Newsletter */}
            <div>
              <NLHeading>JOIN OUR NEWSLETTER</NLHeading>
              <NLText>
                Join us for exclusive promotions, new menu releases, store openings, and much more!
              </NLText>
              <InputWrap>
                <EmailInput
                    type="email"
                    placeholder="Email Address"
                    aria-label="Email Address"
                />
                <InputButton href="https://grainmediterranean.redcatcloud.com.au/universal/register">&gt;</InputButton>
              </InputWrap>
            </div>
            {/* 右列：下载 App（含分割线） */}
            <RightSplit>
              <AppHeading>DOWNLOAD GRAIN APP</AppHeading>
              <AppLinks>
                <AppLink href="https://apps.apple.com/us/app/grain-mediterranean/id6752673762" aria-label="Download on iOS">iOS &gt;</AppLink>
                <AppLink href="https://play.google.com/store/apps/details?id=au.com.redcat.grainmediterranean" aria-label="Download on Android">Android &gt;</AppLink>
              </AppLinks>
            </RightSplit>
          </NewsletterInner>
        </NewsletterBar>

        {/* 原有 Footer 保持不变 */}
        <Container>
          <FiveColumns>
            <Column>
              <ColumnHeading>ABOUT US</ColumnHeading>
              <LinkList>
                <LinkListItem><Link href="/menu">Menu</Link></LinkListItem>
                <LinkListItem><Link href="/story">Our Story</Link></LinkListItem>


                <LinkListItem><Link href="/story#sustainability">Sustainability</Link></LinkListItem>
                <LinkListItem><Link href="/story#community">Community</Link></LinkListItem>
                <LinkListItem><Link href="/foundation">Our Foundation</Link></LinkListItem>
                <LinkListItem><Link href="/catering">Catering</Link></LinkListItem>
                <LinkListItem><Link href="/blog">Blog</Link></LinkListItem>
                <LinkListItem><Link href="/menu">Nutritional Info</Link></LinkListItem>
                <LinkListItem><Link href="/download">Grain App</Link></LinkListItem>
                <LinkListItem><Link href="/career">Careers</Link></LinkListItem>
              </LinkList>
            </Column>

            <Column>
              <ColumnHeading>SUPPORT</ColumnHeading>
              <LinkList>
                <LinkListItem><Link href="/contact">Contact Us</Link></LinkListItem>
                <LinkListItem><Link href="/store">Store</Link></LinkListItem>
              </LinkList>
            </Column>

            <Column>
              <ColumnHeading>LEGAL</ColumnHeading>
              <LinkList>
                <LinkListItem><Link href="/privacy">Privacy Policy</Link></LinkListItem>
                <LinkListItem><Link href="/terms">Terms of Service</Link></LinkListItem>
              </LinkList>
            </Column>

            <WideColumn>
              <LogoContainer>
                <LogoImg src={"https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/LOGO%20for%20website/Yellow.svg"} alt="Grain logo" />
              </LogoContainer>
              <SocialLinksContainer>
                <SocialLink href="https://www.instagram.com/grain_mediterranean/" aria-label="Instagram">
                  <InstagramIcon />
                </SocialLink>
                <SocialLink href="https://www.tiktok.com/@grain.mediterranean?_t=ZN-90Luenq6VJG&_r=1" aria-label="TikTok">
                  <TiktokIcon />
                </SocialLink>
                <SocialLink href="https://www.facebook.com/GrainMediterranean" aria-label="Facebook">
                  <FacebookIcon />
                </SocialLink>
                <SocialLink href="https://www.linkedin.com/company/grain-mediterranean/" aria-label="LinkedIn">
                  <img src={LINKEDIN_ICON_SRC} alt="LinkedIn" />
                </SocialLink>
                <SocialLink href="https://uk.indeed.com/m/jobs?q=Grain%20mediterranean&l=London%2C%20Greater%20London&from=searchOnHP&sameL=1" aria-label="LinkedIn">
                  <img src={INDEED_ICON_SRC} alt="LinkedIn" />
                </SocialLink>
              </SocialLinksContainer>
            </WideColumn>
          </FiveColumns>
        </Container>
      </>
  );
};
